import React, { useEffect } from "react";
import AppHeader from "../components/reusable/header";
import Footer from "../components/reusable/footer";
import {
  LegalMainDiv,
  LegalHeroSection,
  LegalContent
} from "../styles/legal";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <LegalMainDiv>
      <AppHeader
        hideContact={false}
        logo={"/images/sixthWhiteIcon.png"}
        top="0.5rem"
        width="10rem"
        mobileWidth="8rem"
      />
      
      <LegalHeroSection>
        <h1>Privacy Policy</h1>
        <p>Last updated: January 20, 2026</p>
      </LegalHeroSection>

      <LegalContent>
        <p>
          At Sixth, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our products, including our VS Code extension.
        </p>

        <h2>1. Information We Collect</h2>
        
        <h3>Personal Information</h3>
        <p>
          We may collect personal information that you voluntarily provide to us when you register for the service, express an interest in obtaining information about us or our products, when you participate in activities on the service, or otherwise when you contact us. This may include:
        </p>
        <ul>
          <li>Name and contact data (email address)</li>
          <li>Credentials (passwords, hints, and similar security information used for authentication)</li>
          <li>Payment data (if you purchase a subscription)</li>
        </ul>

        <h3>Usage Data and Telemetry</h3>
        <p>
          When you use our VS Code extension, we collect certain telemetry data to help us improve the product and provide a better user experience. This includes:
        </p>
        <ul>
          <li>Performance metrics (latency, error rates)</li>
          <li>Usage patterns (feature adoption, frequency of use)</li>
          <li>System information (OS version, VS Code version)</li>
        </ul>
        <p>
          We strictly do <strong>not</strong> collect or store your source code unless explicitly authorized for specific features (like cloud-based analysis), in which case it is processed ephemerally and encrypted.
        </p>

        <h2>2. How We Use Your Information</h2>
        <p>
          We use the information we collect or receive:
        </p>
        <ul>
          <li>To facilitate account creation and logon process.</li>
          <li>To send you administrative information (product updates, security alerts).</li>
          <li>To fulfill and manage your orders.</li>
          <li>To improve our services and fix bugs through telemetry data analysis.</li>
          <li>To respond to user inquiries and offer support.</li>
        </ul>

        <h2>3. Data Security</h2>
        <p>
          We have implemented appropriate technical and organizational security measures designed to protect the security of any personal information we process. However, please also remember that we cannot guarantee that the internet itself is 100% secure. Although we will do our best to protect your personal information, transmission of personal information to and from our services is at your own risk.
        </p>

        <h2>4. Third-Party Services</h2>
        <p>
          We may share data with trusted third-party service providers who assist us in operating our website, conducting our business, or serving our users, so long as those parties agree to keep this information confidential. We use services like Firebase for authentication and database management.
        </p>

        <h2>5. Your Privacy Rights</h2>
        <p>
          Depending on your location, you may have certain rights regarding your personal information, such as the right to access, correct, or delete your data. If you would like to exercise these rights, please contact us at <a href="mailto:privacy@trysixth.com">privacy@trysixth.com</a>.
        </p>

        <h2>6. Updates to This Policy</h2>
        <p>
          We may update this privacy policy from time to time. The updated version will be indicated by an updated "Revised" date and the updated version will be effective as soon as it is accessible.
        </p>

        <h2>7. Contact Us</h2>
        <p>
          If you have questions or comments about this policy, you may email us at <a href="mailto:ope@trysixth.com">ope@trysixth.com</a>.
        </p>
      </LegalContent>

      <Footer />
    </LegalMainDiv>
  );
};

export default PrivacyPolicy;
